import { useTranslator } from "components/Translator"
import { DescriptionsList, DescriptionItem } from "components/DescriptionsList"
import { AccordionSection } from "components/Accordion"

export const BoatSafety = ({ boat }) => {
  const translator = useTranslator()

  return boat ? (
    <AccordionSection
      label={translator.trans("BoatSafety.title", null, "components")}
    >
      <DescriptionsList>
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.designCategory",
            null,
            "components",
          )}
          value={boat.designCategory}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.safetyEquipment",
            null,
            "components",
          )}
          value={boat.safetyEquipment}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.safetyEquipmentNb",
            null,
            "components",
          )}
          value={boat.safetyEquipmentNb}
        />
        <DescriptionItem
          label={translator.trans("BoatSafety.lifeline", null, "components")}
          value={boat.lifeline}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.anchorBridge",
            null,
            "components",
          )}
          value={boat.anchorBridge}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.emergencyMooring",
            null,
            "components",
          )}
          value={boat.emergencyMooring}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.riggingDisconnectTool",
            null,
            "components",
          )}
          value={boat.riggingDisconnectTool}
        />
        <DescriptionItem
          label={translator.trans("BoatSafety.sonar", null, "components")}
          value={boat.sonar}
        />
        <DescriptionItem
          label={translator.trans("BoatSafety.speedometer", null, "components")}
          value={boat.speedometer}
        />
        <DescriptionItem
          label={translator.trans("BoatSafety.gpsFixed", null, "components")}
          value={boat.gpsFixed}
        />
        <DescriptionItem
          label={translator.trans("BoatSafety.gpsMobile", null, "components")}
          value={boat.gpsMobile}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.emergencyNavigationLight",
            null,
            "components",
          )}
          value={boat.emergencyNavigationLight}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.radarReflector",
            null,
            "components",
          )}
          value={boat.radarReflector}
        />
        <DescriptionItem
          label={translator.trans("BoatSafety.radar", null, "components")}
          value={boat.radar}
        />
        <DescriptionItem label="AIS" value={boat.ais} />
        <DescriptionItem
          label={translator.trans("BoatSafety.phoneMobile", null, "components")}
          value={boat.phoneMobile}
        />
        <DescriptionItem
          label={translator.trans("BoatSafety.vhfFixed", null, "components")}
          value={boat.vhfFixed}
        />
        <DescriptionItem
          label={translator.trans("BoatSafety.vhfGps", null, "components")}
          value={boat.vhfGps}
        />
        <DescriptionItem
          label={translator.trans("BoatSafety.vhfMobile", null, "components")}
          value={boat.vhfMobile}
        />
        <DescriptionItem
          label={translator.trans("BoatSafety.vhfAntenna", null, "components")}
          value={boat.vhfAntenna}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.phoneSatellite",
            null,
            "components",
          )}
          value={boat.phoneSatellite}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.transmitterEpirb",
            null,
            "components",
          )}
          value={boat.transmitterEpirb}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.overboardAlarm",
            null,
            "components",
          )}
          value={boat.overboardAlarm}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.transmitterSatellite",
            null,
            "components",
          )}
          value={boat.transmitterSatellite}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.transmitterAisMob",
            null,
            "components",
          )}
          value={boat.transmitterAisMob}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.survivalRaft",
            null,
            "components",
          )}
          value={boat.survivalRaft}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.survivalRaftFixed",
            null,
            "components",
          )}
          value={boat.survivalRaftFixed}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.survivalContainer",
            null,
            "components",
          )}
          value={boat.survivalContainer}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.survivalWaterCan",
            null,
            "components",
          )}
          value={boat.survivalWaterCan}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.survivalCyalumeStick",
            null,
            "components",
          )}
          value={boat.survivalCyalumeStick}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.survivalFluoresceinSachet",
            null,
            "components",
          )}
          value={boat.survivalFluoresceinSachet}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.survivalManual",
            null,
            "components",
          )}
          value={boat.survivalManual}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatSafety.survivalSuitNb",
            null,
            "components",
          )}
          value={boat.survivalSuitNb}
        />
      </DescriptionsList>
    </AccordionSection>
  ) : null
}
